
import {of as observableOf,  Observable } from 'rxjs';

import {filter, switchMap, share, map, catchError, mergeMap} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { NotificationsAction } from './notifications.actions';
import { BackendService } from '../../services/backend/backend.service';
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { AppState } from '../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { RealtimeService } from "../../services/realtime/realtime.service";
import { RealtimeHub } from "../../enum/realtime/realtime-hub.enum";
import 'rxjs/add/observable/of';
@Injectable()
export class NotificationsEffects {

    constructor(
        private actions$: Actions<NotificationsAction>,
        private backendService: BackendService,
        private realTimeService: RealtimeService,
        private store: Store<AppState>
    ) {}

    @Effect() 
        getNotifications$ = this.actions$
        .pipe(
		ofType(NotificationsAction.getNotifications),
        switchMap(action => {
            return this.backendService.get<DefaultResponse>('communication/notificationhistoric').pipe(
                map(result => {                 
                    if(result.ok) {
                        return { type: NotificationsAction.getNotificationsSuccess, payload: result.value };
                    }
                    return { type: NotificationsAction.getNotificationsError, payload: result.value };
                }),
                catchError((e) => { 
                    return observableOf({ type: NotificationsAction.getNotificationsError, payload: e }); 
                }),);
        }),share(),);

    @Effect() 
        readNotification$ = this.actions$
        .pipe(
		ofType(NotificationsAction.readNotification),
        mergeMap(action => {
            return this.backendService.post<DefaultResponse>('communication/setreadstatus', action.payload).pipe(
                map(result => {                 
                    if(result.ok) {
                        return { type: NotificationsAction.readNotificationSuccess, payload: action.payload };
                    }
                    return { type: NotificationsAction.readNotificationError, payload: result.value };
                }),
                catchError((e) => { 
                    return observableOf({ type: NotificationsAction.readNotificationError, payload: e }); 
                }),);
        }),share(),);

    /** 
     * Notificações em tempo real
     */
    @Effect({ dispatch: false }) 
        getNotificationRealtime$ = this.actions$
        .pipe(
		ofType(NotificationsAction.subscribeNotificationChannel),
        filter(action => this.realTimeService.registerSubscribersAndCheckIfSubscriptionIsNeeded(RealtimeHub.Notification) == true),
        map(action => {

            this.realTimeService.subscribeToNotifications()
                .debounceTime(300)
                .filter(data => data.Body)
                .subscribe(notification => {

                    const payload = {
                        body: notification.Body.Body,
                        details: notification.Body.Detail,
                        readStatus: notification.Body.ReadStatus || 0,
                        sendDate: notification.Body.SendDate,
                        messageID: notification.Body.GuidID
                    };
                    this.store.dispatch({ type: NotificationsAction.subscribeNotificationChannelSuccess, payload: payload });
                });
        }),share(),);
    
}